<div class="{{ cssClass }}">
  <ng-template iuDynamicContainer></ng-template>
</div>
